import styled from 'styled-components'
import theme from 'theme_'

export const SubscriptionTableRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  @media ${theme.devices.tablet} {
    width: 100%;
  }
`

const RowSettings = styled.div`
  min-height: 56px;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 15px 25px;
  border-bottom: 1px solid ${theme.colors.commonShadow};
`

export const SubscriptionTableRowFeatures = styled(RowSettings)`
  flex-basis: 100%;
  line-height: 1.5;
  display: block;
  background-color: white;
  @media ${theme.devices.tablet} {
    flex-basis: 56%;
    text-align: left;
  }
`

export const SubscriptionTableRowIncluded = styled(RowSettings)<{
  isBasicHomePlan: boolean
}>`
  flex-basis: 50%;
  background-color: ${({ isBasicHomePlan }) =>
    isBasicHomePlan ? '#fdf5f080' : theme.colors.white};
  border-right: 1px solid ${theme.colors.commonShadow};
  @media ${theme.devices.tablet} {
    flex-basis: 22%;
    border-right: 1px solid ${theme.colors.commonShadow};
    border-bottom: 1px solid ${theme.colors.commonShadow};
    border-left: 1px solid ${theme.colors.commonShadow};
  }
`

export const SubscriptionTableRowEssentials = styled(RowSettings)<{
  isBasicHomePlan: boolean
}>`
  flex-basis: 50%;
  background-color: ${({ isBasicHomePlan }) =>
    isBasicHomePlan ? '#fdf5f080' : theme.colors.white};
  @media ${theme.devices.tablet} {
    flex-basis: 22%;
  }
`

export const SubscriptionTableRowNote = styled.span`
  font-size: 12px;
`
